module.exports = __webpack_public_path__ + "img/no-data_location.4b98daf4.svg";